$(document).ready(function(){
  //Create Cookie Function --------------------
  function cookieCreate(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    } else {
        var expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }
  
  //Read Cookie Function --------------------------
  function cookieRead(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  
  //Erase Cookie Function --------------------------
  function cookieErase(name) {
    cookieCreate(name, "", -1);
  }
  
  //Function to switch currency automatically.
  var geoip_redirect = function(currency_code){
    //console.log(currency_code);
    var form = document.createElement("form");
      form.method = "post";
      form.action = "/localization";
      document.body.appendChild(form);
    var ele1 = document.createElement("INPUT");         
      ele1.name="currency_code"
      ele1.value = currency_code;
      ele1.type = 'hidden'
      form.appendChild(ele1);
    var ele2 = document.createElement("INPUT");         
      ele2.name="return_to"
      ele2.value = '/';
      ele2.type = 'hidden'
      form.appendChild(ele2);
    var ele3 = document.createElement("INPUT");         
      ele3.name="_method"
      ele3.value = 'put';
      ele3.type = 'hidden'
      form.appendChild(ele3);
    var ele4 = document.createElement("INPUT");         
      ele4.name="form_type"
      ele4.value = 'localization';
      ele4.type = 'hidden'
      form.appendChild(ele4);
    form.submit();
  };
  
  var locale_redirection_checked = cookieRead('locale_redirection_checked');
  
  if(!locale_redirection_checked){
    //var geoip_request_url = 'https://freegeoip.app/json/';
    var geoip_request_url = 'https://api.ipbase.com/json/?apikey=clqvsm3p3YxHKCtL9n10fupNWq1PbDbIM77iW1Pr';
    $.getJSON(geoip_request_url, function (ipData) {
      console.log(ipData);
      var countryCode = ipData.country_code ;
      var redirectUrl = null;
      var redirectName = null;
      var storeName = null;

      if(countryCode == 'US'){
        redirectUrl = 'https://dimplecolor.com';
        redirectName = 'dimplecolor.com';
        storeName = 'US';
      } else if(countryCode == 'AU' || countryCode == 'NZ'){
        redirectUrl = 'https://dimplecolor.com.au';
        redirectName = 'dimplecolor.com.au';
        storeName = 'Australian';
      }
  
      if(redirectUrl){
        var timeleft = 10;
        var redirectionTimer = setInterval(function(){
          $('.redirect-popup .seconds').text(timeleft);
          if(timeleft <= 0){
            clearInterval(redirectionTimer);
            //window.location.href = 'https://dimplecolor.com.au';
          }
          timeleft -= 1;
        }, 1000);
  
        $('.redirect-popup .btn-stay').on('click', function(){
          cookieCreate('locale_redirection_checked', true, 30);
          clearInterval(redirectionTimer);
          $('body').removeClass('redirect-popup-visible');
        });

        var flag_src = $('.redirect-popup .flag-wrap img').data('src-' + countryCode.toLowerCase());
        if(flag_src){
          $('.redirect-popup .flag-wrap img').attr('src', flag_src);
        } else {
          $('.redirect-popup .flag-wrap').hide();
        }
        $('.redirect-popup .country-name').text(ipData.country_name);
        $('.redirect-popup .btn-redirect').attr('href', redirectUrl);
        $('.redirect-popup .btn-redirect .link').text(redirectName);
        $('.redirect-popup .store-name').text(storeName);

        $('body').addClass('redirect-popup-visible');
      } else {
        cookieCreate('locale_redirection_checked', true, 30);
        if (countryCode != 'US') {
          for(var key in currencyCodes){
            if(key == countryCode){
              if(currentCurrencyCode != currencyCodes[key]) {
                //console.log('redirect..', currentCurrencyCode, currencyCodes[key]);
                geoip_redirect(currencyCodes[key]);
              }          
              break;
            }
          }
        }
      }
    });
  }
});